import React from "react";
import { FaFileDownload } from "react-icons/fa";

const About = () => {
  return (
    <div id="about" className="about-me-wraper">
      <h1 className="about-me-header">About Me</h1>
      <div className="about_info">
        <div className="my_detail_box">
          <p className="my_detail">
            Hello! I'm Prathamesh Sarode, a passionate software engineer. I
            develop web applications and websites. My core skill is based on
            JavaScript. I love to make the web more open to the world. I have
            graduated with a bachelor's degree in Computer Science & Technology
            from Shivaji University at Kolhapur, Maharashtra in 2020. I am
            available for any job opportunity which suits me best.
          </p>
          <a
            href="https://drive.google.com/file/d/17eGyK9wiWlfV6TBHYhU_-bYGjetOpObX/view?usp=drivesdk"
            target="_blank"
            rel="noreferrer"
            className="resume-button"
          >
            <FaFileDownload className="resume-logo" /> Download Resume
          </a>
        </div>

        <div className="about_hobby">
          <h2 className="hobby_title">Hobbies</h2>
          <div className="hobby_img_container">
            <div className="hobby_img_box">
              {/* <span className="hobby_name">Gaming</span> */}
              <img
                className="hobby_img1"
                src="https://cdn.shopify.com/s/files/1/0306/6419/6141/articles/coding_languages_600x600_crop_center.png?v=1619126283"
                alt="hobby"
              />
            </div>
            <div className="hobby_img_box">
              {/* <span className="hobby_name">Gaming</span> */}
              <img
                className="hobby_img1"
                src="https://developer-tech.com/wp-content/uploads/sites/3/2021/02/unity-covid-19-coronavirus-gaming-game-development-research-report-impact-study.jpg"
                alt="hobby"
              />
            </div>
          </div>
          <div className="hobby_img_box">
            {/* <span className="hobby_name">Gaming</span> */}
            <img
              className="hobby_img1"
              src="https://t3.ftcdn.net/jpg/02/92/99/26/360_F_292992646_Y6zSoZJLHCxeghn5khqvNcQ9Qf01J2oi.jpg"
              alt="hobby"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
